"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldInfo = void 0;
const core_shared_1 = require("@ikegps/core-shared");
const theme_1 = require("../../components/theme");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const services_1 = require("../../services");
const capture_thumbnail_1 = require("../capture.thumbnail/capture.thumbnail");
const capture_thumbnail_style_1 = require("../capture.thumbnail/capture.thumbnail.style");
const CSS = {
    container: 'c-FieldInfo',
    captures: 'c-FieldInfo__Captures',
    stat: {
        container: 'c-FieldInfo__Stat',
        label: 'c-FieldInfo__Stat--label',
        name: 'c-FieldInfo__Stat--name',
        icon: 'c-FieldInfo__Stat--icon',
        value: 'c-FieldInfo__Stat--value'
    }
};
(0, theme_1.addStyles)({
    [CSS.container]: {
        width: '100%'
    },
    [CSS.stat.container]: {
        width: '100%',
        display: 'flex',
        'justify-content': 'space-between',
        'margin-left': theme_1.DefaultTheme.space(2)
    },
    [CSS.stat.label]: {
        flex: 1,
        display: 'flex'
    },
    [CSS.stat.icon]: {
        'font-size': theme_1.DefaultTheme.font.size,
        color: theme_1.DefaultTheme.background.mediumGrey,
        'margin-left': theme_1.DefaultTheme.space(1)
    },
    [CSS.stat.value]: {
        flex: 1,
        color: theme_1.DefaultTheme.font.color.supporting
    },
    [CSS.captures]: {
        width: '100%',
        display: 'flex',
        'justify-content': 'space-around',
        'margin-top': theme_1.DefaultTheme.space(1),
        'overflow-x': 'auto'
    },
    [`${CSS.captures} .${capture_thumbnail_style_1.CSS.container}`]: {
        width: '130px',
        'min-width': '130px',
        height: '130px',
        'min-height': '130px'
    }
});
const THUMBNAIL_CTX = {
    crosshair: true,
    title: ''
};
exports.FieldInfo = {
    viewCaptures(collection, captures, stats = []) {
        const captureChildren = [];
        for (const capture of captures) {
            THUMBNAIL_CTX.title = services_1.Services.DateTime.formatDateTime(capture.collectedAt.iso);
            captureChildren.push(capture_thumbnail_1.CaptureThumbnail.view(collection, capture, THUMBNAIL_CTX));
        }
        const statNodes = [];
        for (const stat of stats) {
            statNodes.push(exports.FieldInfo.viewStat(stat.name, stat.value));
        }
        return (0, mithril_1.m)('div', { className: CSS.container }, [
            ...statNodes,
            (0, mithril_1.m)('div', { className: CSS.captures }, captureChildren)
        ]);
    },
    viewStat(name, value) {
        let displayValue;
        if (typeof value === 'number') {
            displayValue = core_shared_1.IkeUnit.display(value, services_1.Services.UserSettings.units);
        }
        else {
            displayValue = value;
        }
        return (0, mithril_1.m)('div', { className: CSS.stat.container }, [
            (0, mithril_1.m)('div', { className: CSS.stat.label }, (0, i18n_1.Translate)(name)),
            (0, mithril_1.m)('span', { className: CSS.stat.value }, displayValue)
        ]);
    },
    viewVectorInline(value) {
        const length = core_shared_1.IkeUnit.display(value.distance, services_1.Services.UserSettings.units, core_shared_1.IkeUnit.METER);
        const angle = core_shared_1.IkeUnit.display(value.bearing, core_shared_1.IkeUnit.DEGREE, core_shared_1.IkeUnit.RADIAN);
        return (0, i18n_1.Translate)(i18n_1.T.FIELD_VECTOR_P2P_DISPLAY, { length, angle });
    }
};
//# sourceMappingURL=field.info.js.map